<script>
    import Skill from '../js/skill';
    import SkillDisplay from '../components/skill_display.svelte';
    import ProjectDisplaySkill from '../components/project_display_skill.svelte';
    const programmingLanguages = [
        new Skill("Dart", 4),
        new Skill("Python", 3),
        new Skill("Java", 3),
        new Skill("Kotlin", 3),
        new Skill("TypeScript", 3),
        new Skill("JavaScript", 3),
        new Skill("C#", 2),
        new Skill("HTML/CSS", 2),
        new Skill("Swift", 2),
    ];
    const frameworksAndLibraries = [
        new Skill("Flutter", 4),
        new Skill("React Native", 3),
        new Skill("Spring", 3),
        new Skill("Pillow", 2),
        new Skill("TensorFlow", 2),
        new Skill("Svelte", 2),
        new Skill("Django", 1),
        new Skill(".NET", 1),
    ];
    const databaseAndTools = [
        new Skill("Firebase", 4),
        new Skill("MySQL", 2),
        new Skill("Google AdMob", 2),
        new Skill("Git", 2),
        new Skill("Docker", 2),
        new Skill("Postman", 2),
        new Skill("Azure", 1),
    ];
    const designTools = [
        new Skill("Rotato", 4),
        new Skill("Rive", 3),
        new Skill("Adobe Illustrator", 2),
    ];
    const projectManagement = [
        new Skill("Scrum", 3),
        new Skill("Agile", 3),
        new Skill("Trello", 3),
    ];
    const languages = [
        new Skill("Danish", 4),
        new Skill("English", 4),
        new Skill("Spanish", 3),
        new Skill("Norwegian", 2),
        new Skill("Russian", 2),
        new Skill("French", 1),
    ];
    const ides = [
        new Skill("Android Studio", 4),
        new Skill("WebStorm", 4),
        new Skill("PyCharm", 4),
        new Skill("IntelliJ", 4),
        new Skill("VS Code", 3),
        new Skill("Xcode", 3),
    ];
    const skillList = [
        programmingLanguages,
        frameworksAndLibraries,
        databaseAndTools,
        designTools,
        ides,
        projectManagement,
        languages,
    ];
    const titles = [
        "Programming Languages",
        "Frameworks & Libraries",
        "Database & Tools",
        "Design Tools",
        "IDE's",
        "Project Management",
        "Languages",
    ];
    const skillTypes = [
        new Skill("I feel at home doing this", 4),
        new Skill("I'm doing great at this", 3),
        new Skill("I'm doing fine at this", 2),
        new Skill("I'm a beginner at this", 1),
    ];

</script>

<section id="skills">
    <div id='container'>
        <div style="margin-right: 10%;"/>
        <div id='container-header'>
            <h1>Skills</h1>
            <div style="height: 0px"/>
            <p>These colors show my experience level with the various skills:</p>
            {#each skillTypes as skill}
                <ProjectDisplaySkill {skill} />
            {/each}
        </div>
        <div id='container-text'>
            {#each skillList as skillList, index}
                <SkillDisplay skillList={skillList} title={titles[index]} />
            {/each}
        </div>
    </div>
</section>


<style>
    #container {
        width: 100vw;
        height: calc(80vh - 80px);
        background-color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: end;
    }

    #container-header {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 10%;
        text-align: center;
    }

    #container-text {
        width: 70%;
        display: flex;
        flex-direction: row;
        overflow-x: auto; 
        white-space: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.9);
        text-align: center;
        margin-bottom: 12px;
    }

    p {
        color: rgba(0, 0, 0, 0.6);
    }

    @media (max-width: 952px) {
        #container {
            display: block;
            flex-direction: column;
            margin-left: 0px;
            margin-right: 0px;
            padding: 0%;
            width: 100vw;
            height: auto;
            margin-top: 100px;
            margin-bottom: 96px;
        }
        #container-text, #container-header {
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        #container-header {
            margin-bottom: 48px;
        }

        p {
            width: 80%;
        }
    }

</style>